<form novalidate #propertyRentalDetailsSectionForm="ngForm">
    <tg-row
        *ngIf="draftLoaded$ | async"
        class="property-rental-details-section"
    >
        <tg-col md="9" sm="12">
            <tg-row>
                <tg-col sm="12">
                    <h2>Your details</h2>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-input-container label="Mobile">
                        <input
                            ngModel
                            name="mobilePhone"
                            tgTextInput
                            tgInputMask
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.mobile
                            "
                            [type]="
                                validation.propertyInformation.mobile
                                    ?.type || 'text'
                            "
                            [validation]="
                                validation.propertyInformation.mobile
                                    | toValidator
                            "
                        />
                        <tg-input-mask-pattern
                            [regex]="mobilePhoneNumberRegex"
                            pattern="*** *** *****"
                            allow="[0-9]"
                        >
                        </tg-input-mask-pattern>
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-input-container label="Home">
                        <input
                            ngModel
                            name="homePhone"
                            tgTextInput
                            tgInputMask
                            (blur)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.landLine
                            "
                            [type]="
                                validation.propertyInformation.landLine
                                    ?.type || 'text'
                            "
                            [validation]="
                                validation.propertyInformation.landLine
                                    | toValidator
                            "
                        />
                        <tg-input-mask-pattern
                            [regex]="homePhoneNumberRegex"
                            pattern="** *** ****"
                            allow="[0-9]"
                        >
                        </tg-input-mask-pattern>
                    </tg-input-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="4" sm="12">
                    <tg-select-container
                        class="hide-optional-label"
                        label="Best contact time"
                    >
                        <select
                            tgSelect
                            ngModel
                            name="contactTime"
                            (change)="publish()"
                            [(ngModel)]="
                                draftData.propertyInformation.contactTimes
                            "
                        >
                            <option
                                *ngFor="let time of metadata.contactTimes"
                                [ngValue]="time.value"
                            >
                                {{ time.display }}
                            </option>
                        </select>
                    </tg-select-container>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col md="8" sm="12">
                    <tg-radio-group
                        label="Are you a registered property agent?"
                        class="
                            property-rental-details-section__registered-agent-group
                        "
                        ngModel
                        name="Radio group name"
                        (change)="onIsPropertyAgentChange($event.value)"
                        [(ngModel)]="
                            draftData.propertyInformation.isPropertyAgent
                        "
                        [validation]="
                            validation.propertyInformation.isPropertyAgent
                                | toValidator
                        "
                    >
                        <tg-radio-item
                            [value]="true"
                            label="Yes"
                            class="
                                property-rental-details-section__registered-agent-option
                            "
                        >
                        </tg-radio-item>
                        <tg-radio-item
                            [value]="false"
                            label="No"
                            class="
                                property-rental-details-section__registered-agent-option
                            "
                        >
                        </tg-radio-item>
                    </tg-radio-group>
                    <tg-row
                        *ngIf="draftData.propertyInformation.isPropertyAgent"
                    >
                        <tg-col>
                            <div class="o-nested-inputs-container">
                                <tg-input-container
                                    label="{{
                                        validation.propertyInformation.name
                                            ?.name
                                    }}"
                                    showRemainingCharacters="false"
                                >
                                    <input
                                        tgTextInput
                                        name="name"
                                        type="text"
                                        (blur)="publish()"
                                        [(ngModel)]="
                                            draftData.propertyInformation.name
                                        "
                                        [validation]="
                                            validation.propertyInformation.name
                                                | toValidator
                                        "
                                    />
                                </tg-input-container>
                                <tg-input-container
                                    label="{{
                                        validation.propertyInformation.agency
                                            ?.name
                                    }}"
                                    showRemainingCharacters="false"
                                >
                                    <input
                                        tgTextInput
                                        name="agency"
                                        type="text"
                                        (blur)="publish()"
                                        placeholder="e.g. Harcourts"
                                        [(ngModel)]="
                                            draftData.propertyInformation.agency
                                        "
                                        [validation]="
                                            validation.propertyInformation
                                                .agency | toValidator
                                        "
                                    />
                                </tg-input-container>
                            </div>
                        </tg-col>
                    </tg-row>
                </tg-col>
            </tg-row>
            <tg-row>
                <tg-col>
                    <p class="p-secondary-copy">
                        Licensed agents are required to disclose their status
                        under the Real Estate Agents Act 2008.
                    </p>
                </tg-col>
            </tg-row>
        </tg-col>
    </tg-row>
</form>
